<h3  mat-dialog-title class="text-uppercase" >
  PassCode Check
</h3>

<mat-dialog-content class="mat-typography" style="padding: 20px;">
  <form (ngSubmit)="checkPasscode()" class="passcode-form">
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Enter Passcode</mat-label>
      <input
        matInput
        type="password"
        [(ngModel)]="enteredPasscode"
        name="passcode"
        required
      />
    </mat-form-field>

    <!-- <div *ngIf="errorMessage" style="color: red; margin-top: 8px;">
      {{ errorMessage }}
    </div> -->
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" >
  <button mat-raised-button color="primary" (click)="checkPasscode()">Check</button>
</mat-dialog-actions>
